import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Col, Row} from "reactstrap";
import Parser from "react-html-parser";

class SurveyFooter extends Component {

  render() {
    if (!this.props.survey.footerText) {
      return null;
    }

    return (
      <div className="mt-3 mb-3 footerCard">
        <Row>
          <Col>
            {Parser(this.props.survey.footerText)}
          </Col>
        </Row>
      </div>
    )
  }
}

SurveyFooter.propTypes = {
  survey: PropTypes.shape({
    footerText: PropTypes.string,
  }).isRequired,
};

export default SurveyFooter;